  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector('.tp-bgcolor');

if (section) {
  gsap.fromTo(
    section,
    { backgroundColor: "#BAADD8" }, // cor inicial
    {
      backgroundColor: "#FAF8FF", // cor final
      duration: 1,
      scrollTrigger: {
        trigger: section,
        start: "top center",
        end: "bottom center",
        scrub: true,
      }
    }
  );
}